// export const API_BASE_URL = 'http://localhost:5001'; 
// export const API_BASE_URL = 'https://api.testmysitewithai.com'; 

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';
// export const API_BASE_URL = 'https://staging-api.darknore.ai'